export const generatePhoneBookCall = `
  query generatePhoneBookCall($request: PhoneBookAirRequest!) {
    phoneBookAirEntry(request: $request) {
            phoneNumber
            debugField
            chatBox
    }
  }
`
